import type {ReactElement} from 'react';
import {FontItem} from '@Components/font-selector-panel/components/font-item';
import type {OnDeleteFontItemCallback, OnSelectFontFamilyCallback} from '@Components/font-selector-panel/font-selector.types';
import type {FontData} from '@Libraries/font-library';
import {useAppSelector} from '@/hooks';

interface FontsListProps {
  className?: string;
  fontNames: FontData[];
  isUserUploadedFontList?: boolean;
  onSelectFontFamily?: OnSelectFontFamilyCallback;
  selectedFontFamily?: string;
  isSelectedFontLoading?: boolean;

  onDeleteFontItem?: OnDeleteFontItemCallback;
}

export function FontsList({
  className = '',
  isUserUploadedFontList = false,
  onDeleteFontItem = (): void => {},
  onSelectFontFamily = (): void => {},
  selectedFontFamily = '',
  isSelectedFontLoading = false,
  ...props
}: FontsListProps): ReactElement<any> | null {
  const selectedFontInRedux = useAppSelector((state) => {
    return state.fontSelector.selectedFont;
  });

  const onClickHandler = (font: FontData): void => {
    onSelectFontFamily(font);
  };

  const onDeleteFontItemHandler = (font: FontData): void => {
    onDeleteFontItem(font);
  };

  const isFontSelected = (fontFamily: string): boolean => {
    if (selectedFontFamily) {
      return selectedFontFamily === fontFamily;
    }
    return fontFamily === selectedFontInRedux.fontFamily;
  };

  const prepItems = (): ReactElement<any>[] | null => {
    if (!props.fontNames) {
      return null;
    }

    return props.fontNames.map((fontName) => {
      return (
        <FontItem
          showDeleteActions={isUserUploadedFontList}
          onDelete={(): void => {
            onDeleteFontItemHandler(fontName);
          }}
          onClick={(): void => {
            onClickHandler(fontName);
          }}
          key={fontName.idfont}
          fontName={fontName.fontFamily}
          isSelected={isFontSelected(fontName.fontFamily)}
          isLoading={isSelectedFontLoading}
        />
      );
    });
  };

  return <ul className={`${className} spacing-m-0`}>{prepItems()}</ul>;
}
